/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';

import styles from '../../../../ActionDrawer.module.scss';

/*
type TypeProps = {
    formData: Object
} & TranslatorProps;
*/

@translate()
@inject('actionDrawerStore')
@observer
export default class UnarchiveManufacturerSuccess extends React.Component<*> {
  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const response: Object = this.props.response;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:manufacturers.unarchived')}
          >
            <p>{t('general:manufacturers.messages.unarchived')}</p>
            <p>{t('general:manufacturers.messages.globally_unavailable')}</p>
            <React.Fragment>
              <ul>
                <li>
                  <b>{t('general:manufacturer')}</b>:
                </li>
                <li>{`${response.name}`}</li>
              </ul>
            </React.Fragment>
          </ActionDrawerBlock>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
